export default __webpack_public_path__ + "static/media/form-tender.7169fc8f.png";